// Rails member URLs carry `to_param` slugs (`7003-fixture-casey`) and Rails finds the record
// by the leading integer, so route adapters read ids the same way.
export const recordIdParam = (value: string | undefined): number =>
  Number.parseInt(value ?? '', 10);
